"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iconChildSize = exports.PRIORITY = exports.SIZES = exports.SKINS = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _iconChildSize;

var SKINS = {
  standard: 'standard',
  inverted: 'inverted',
  light: 'light',
  transparent: 'transparent',
  premium: 'premium'
};
exports.SKINS = SKINS;
var SIZES = {
  tiny: 'tiny',
  small: 'small',
  medium: 'medium',
  large: 'large'
};
exports.SIZES = SIZES;
var PRIORITY = {
  primary: 'primary',
  secondary: 'secondary'
};
exports.PRIORITY = PRIORITY;
var iconChildSize = (_iconChildSize = {}, (0, _defineProperty2["default"])(_iconChildSize, SIZES.tiny, '18px'), (0, _defineProperty2["default"])(_iconChildSize, SIZES.small, '18px'), (0, _defineProperty2["default"])(_iconChildSize, SIZES.medium, '24px'), (0, _defineProperty2["default"])(_iconChildSize, SIZES.large, '24px'), _iconChildSize);
exports.iconChildSize = iconChildSize;